import { render } from "./subPt.vue?vue&type=template&id=22267397&scoped=true"
import script from "./subPt.vue?vue&type=script&lang=js"
export * from "./subPt.vue?vue&type=script&lang=js"

import "./subPt.vue?vue&type=style&index=0&id=22267397&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22267397"]])

export default __exports__